export enum Status {
  success = "SUCCESS",
  error = "ERROR",
  inProgress = "IN_PROGRESS",
  warning = "WARNING",
  default = "DEFAULT",
  pending = "PENDING",
}

export interface actionType {
  text: string;
  type: "url" | "screen";
  action: string;
}

export enum WidgetType {
  BUTTON = "BUTTON",
  INFO = "INFO",
}

export interface DisplayInfoProps {
  status?: Status;
  title: Array<string>;
  description?: Array<string>;
  actionLink?: actionType;
  header?: {
    heading?: string;
    actionLink?: actionType;
  };
  className?: string;
  widgetType: WidgetType;
}
